import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component, Fragment } from 'react';
import { DataAPI } from '../../data/DataAPI';
import { Immocom } from '../../specifique/immocom';
import { FicheAPI } from '../Fiche/FicheAPI';
import { FicheAPIParametres } from '../Fiche/FicheAPIParametres';
import { FicheAPIBalisesRetour } from '../Fiche/FicheAPIBalisesRetour';
import { FicheSocietes } from '../Fiche/FicheSocietes';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
**********************************************************************************************************************
PROPS :
    ATTRIBUTS :
        -
    METHODES :
        -
**********************************************************************************************************************
*/

export class DetailsListAPI extends Component {

    static defaultProps = {};

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this._filtres = {};
        this._isSortedDescending = false;
        this._sortedColumn = "categorie";
        this._objetState = {
            groups: [],
            items: [],
            itemActif: {},
            /* --- */
            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true
        };
        this.state = { ... this._objetState };
    };

    _creationContent = () => {
        return <DetailsList
            columns={this._columns}
            compact
            groupProps={{ showEmptyGroups: true }}
            groups={this.state.groups}
            items={this.state.items}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            selectionMode={SelectionMode.none}
        />
    }

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des APIs en cours..."
        });

        let chargementAPIs = DataAPI._chargementAPIs(this._filtres, this._sortedColumn, this._isSortedDescending);
        chargementAPIs.then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                let listeAPIs = responseFetch.reponseAPIobjet || [];
                listeAPIs.sort((a, b) => { return a.categorie - b.categorie; });
                const stateTemp = {
                    groups: this._getGroups(listeAPIs),
                    items: listeAPIs
                };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
            }
            else {
                this.setState({
                    groups: [],
                    items: []
                });
                Immocom.onTraitementErreurPromise(this, retourVerif);
            }
        });
    };

    _getGroups = (listeAPIs) => {

        const apisGroupeesParCategorie = listeAPIs.reduce((memo, api) => {
            const categorie = api.categorie || "Sans catégorie";
            if (!memo[categorie])
                memo[categorie] = [];
            memo[categorie].push(api);
            return memo;
        }, {});

        let groups = [];
        let startIndex = 0
        for (const [categorie, apis] of Object.entries(apisGroupeesParCategorie)) {
            const count = apis.length;
            groups.push({ key: categorie, name: categorie, startIndex, count });
            startIndex += count;
        };

        return groups;

    };

    _getColumns = () => {
        return [
            {
                key: "idAPI",
                minWidth: 20,
                maxWidth: 20,
                name: "",
                onRender: (item) => {
                    const idAPI = item.idAPI;
                    return <span title={idAPI} className="badge badge-secondary">{idAPI}</span>;
                }
            },
            {
                key: "nomAPI",
                name: "Nom",
                minWidth: 250,
                maxWidth: 250,
                onRender: (item) => {
                    const nomAPI = item.nomAPI;
                    return <span title={nomAPI}>{nomAPI}</span>;
                }
            },
            {
                key: "description",
                name: "Description",
                onRender: (item) => {
                    const description = item.description;
                    return <span title={description}>{description}</span>;
                }
            },
            {
                key: "nomAction",
                name: "Action",
                onRender: (item) => {
                    const nomAction = item.nomAction;
                    return <span title={nomAction}>{nomAction}</span>;
                }
            },
            {
                key: "nomTable",
                name: "Table",
                onRender: (item) => {
                    const nomTable = item.nomTable;
                    return <span title={nomTable}>{nomTable}</span>;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "in",
                minWidth: 25,
                maxWidth: 25,
                name: "Consulter/modifier",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "CloudDownload" }}
                        onClick={this._togglePanel("APIParametres", true, item, false)}
                        title="Consulter/modifer les paramètres de l'API"
                    />;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "out",
                minWidth: 25,
                maxWidth: 25,
                name: "Consulter/modifier",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "CloudUpload" }}
                        onClick={this._togglePanel("APIBalisesRetour", true, item, false)}
                        title="Consulter/modifer les balises de retour de l'API"
                    />;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "display",
                minWidth: 25,
                maxWidth: 25,
                name: "Afficher les sociétés autorisées à consommer cette API",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Lock" }}
                        onClick={this._togglePanel("Societes", true, item, false)}
                        title="Afficher les sociétés autorisées à consommer cette API"
                    />;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "edit",
                minWidth: 25,
                maxWidth: 25,
                name: "Consulter/modifier l'API",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Edit" }}
                        onClick={this._togglePanel("API", true, item, false)}
                        title="Consulter/modifier l'API"
                    />;
                }
            }
        ];
    };

    _getFarItems = () => {
        return [{
            key: "nombreEnregistrement",
            name: this.state.items.length
        }];
    };

    _getItems = () => {
        return [
            {
                key: "search",
                onRender: () => <SearchBox
                    className="searchBox"
                    onClear={(ev) => this._onSearch("")}
                    onSearch={(newValue) => this._onSearch(newValue)}
                    placeholder="Recherche rapide"
                />
            }
        ];
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender({
                ...props,
                onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
            })}
        </Sticky>
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this._chargementDonnees();
    };

    _togglePanel = (nomPanel, isOpen, item, rechargerLesDonnees) => () => {
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                itemActif: item || {}
            },
            rechargerLesDonnees ? this._chargementDonnees : null
        );
    };

    componentDidMount = () => { this._chargementDonnees(); };

    render = () => {

        const content = this._creationContent();
        const { itemActif, afficherPanelAPI, afficherPanelAPIParametres, afficherPanelSocietes, afficherPanelAPIBalisesRetour } = this.state;
        const { idAPI } = itemActif;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    ariaLabel={"Utiliser les flèches droite et gauche pour naviguer"}
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <FicheAPI
                {...itemActif}
                isOpen={afficherPanelAPI}
                onDismiss={this._togglePanel("API", false, null, false)}
                onMiseAJour={this._togglePanel("API", false, null, true)}
            />

            <FicheAPIParametres
                idAPI={idAPI}
                isOpen={afficherPanelAPIParametres}
                onDismiss={this._togglePanel("APIParametres", false, null, false)}
            />

            <FicheAPIBalisesRetour
                headerText={`Balise de retour de l'API « ${itemActif.nomAPI} »`}
                idAPI={idAPI}
                isOpen={afficherPanelAPIBalisesRetour}
                onDismiss={this._togglePanel("APIBalisesRetour", false, null, false)}
            />

            <FicheSocietes
                headerText={`Sociétés autorisées à consommer l'API « ${itemActif.nomAPI} »`}
                idAPI={idAPI}
                isOpen={afficherPanelSocietes}
                onDismiss={this._togglePanel("Societes", false, null, false)}
            />

        </Fragment>;

    };

};